var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24PxIconX = function Svg24PxIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 11.811 21.5 3h-2.682l-4.839 6.782L9.316 3H1.937l6.052 9.256-6.49 9.19h3.032l5.166-7.161 4.924 7.162H22l-6.313-9.636Zm-4.182 1.535-.715-1.021-4.685-7.126h2.448l3.587 5.558.715 1.021 4.964 7.525H15.37l-3.867-5.957Z",
    fill: "#383C44"
  })));
};
export default Svg24PxIconX;